import {
  types,
  IGetMediaTypeGroupsAction,
  IGetMediaTypeGroupsSuccessAction,
  IFailureAction,
} from '../types/mediaTypeGroups'
import { IMediaTypeGroup } from '../types/mediaTypeGroup'

export const getMediaTypeGroups = (): IGetMediaTypeGroupsAction => ({
  type: types.GET_MEDIA_TYPE_GROUPS__STARTED,
})

export const getMediaTypeGroupsSuccess = (
  list: IMediaTypeGroup[]
): IGetMediaTypeGroupsSuccessAction => ({
  type: types.GET_MEDIA_TYPE_GROUPS__SUCCESS,
  list,
})

export const getMediaTypeGroupsFailure = (message: string): IFailureAction => ({
  type: types.GET_MEDIA_TYPE_GROUPS__FAILURE,
  message,
})
